import { TableSchema } from '../metadata-schema';
import { dim_vk_vak } from './dim_vk_vak';
import { dim_mw_medewerker } from './dim_mw_medewerker';
import { Niveau } from '../enums/Niveau';

export const dim_lg_lesgroep: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_lg_lesgroep",
	"description": "Definitie voor dimension tabel dim_lg_lesgroep uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek"
	],
	"properties": {
		"lg_abb_docenten": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lg_abb_vak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lg_abb_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lg_co_vak_land": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lg_d_schooljaar_tm": {
			"type": "string",
			"format": "date",
			"label": "Lesgroep tot",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lg_d_schooljaar_va": {
			"type": "string",
			"format": "date",
			"label": "Lesgroep vanaf",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lg_des_lesgroep": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lg_fk_vk": {
			"description": "Definitie voor dimension tabel dim_vk_vak uit de CumLaude DWH",
			"type": "object",
			"schema": dim_vk_vak
		},
		"lg_fks_mw": {
			"type": "array",
			"items": {
				"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
				"type": "object",
				"schema": dim_mw_medewerker
			}
		},
		"lg_nm_docenten": {
			"type": "string",
			"label": "Docenten",
			"category": "Vak",
			"example": "JSL, DKE, ..."
		},
		"lg_nm_lesgroep": {
			"type": "string",
			"label": "Lesgroep",
			"category": "Vak",
			"example": "1een, h5cnetl, ...",
			"description": "De naam van de lesgroep waar de leerling in zit voor het betreffende vak."
		},
		"lg_nm_niveau": {
			"label": "Niveau",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"type": "string",
			"schema": Niveau
		},
		"lg_nm_schooljaar": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lg_nm_vak": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"lg_nm_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
